import React from 'react';
import { CalendarEvent, useEventsArchiveList } from './useEventsAdminList';
import { FormControl, useFields } from '../../../toolympus/components/schemed';
import { FormGrid, SimpleList } from '../../../toolympus/components/primitives';
import { Typography } from '@mui/material';
import { SimplePowerDocViewer } from '../../../toolympus/components/PowerDoc/SimplePowerDocViewer';
import { TimeDisplay } from '../../../toolympus/components/schemed/TimeDisplay';

interface Props {
  
}

export const CalendarArchivePage = (props: Props) => {
  const data = useEventsArchiveList();

  const fields = useFields({
    defaultFields: [
      "title",
      "start_datetime",
      "registration_status",
      "price_option",
      "created_at",
      "is_published",
    ],
    blacklist: [
      "description",
      "description_ru",
      "search_highlights",
    ],
    schema: data.schema,
    storageKey: "_riac_eventadm_fields",
    extraSettings: {
      description_short: { tableControl: SimplePowerDocViewer },
      created_at: { utcToLocal: true, formatAsDate: true },
      updated_at: { utcToLocal: true, formatAsDate: true },
      published_at: { utcToLocal: true, formatAsDate: true },
      actualized_at: { utcToLocal: true, formatAsDate: true },
    }
  });

  return (<>
    <SimpleList
      data={{
        ...data,
        filter: data.filter.filter,
        setFilter: data.filter.setFilter,
        create: () => { data.newRecord.startEditing(); return Promise.resolve({ _id: -1 } as CalendarEvent); }
      }}
      fields={[
      ]}
      fieldElement={f => {
        switch(f) {
          case "end_datetime":
            return r => <TimeDisplay field="end_datetime" row={r} schema={{}} config={{ format: "HH:mm"}} />
        }
      }}
      schema={data.schema}
      getLinkValue={cr => `/archive-events/${cr._id}`}
      linkFields={[ "_id", "title" ]}
      title="Events Archive"
      noCreate
      noNewItemHotkey
      searchAuto
      searchAutoFocus
      fieldSetings={fields}
      fieldFilters={data.filtering}
      sorting={data.sorting}
      tableProps={{
        tailAnchor: data.limitTrigger.pagingAnchor,
      }}
      headerActions={<>
        <Typography variant="caption" color="textSecondary">Events: {data.count.data.total_records}</Typography>
      </>}
      headerViewActions={<>
        <FormGrid noMargin columns="100px">
          <FormControl
            field="year"
            row={{ year: data.extraFilters.year.value }}
            onChange={(o,c) => data.extraFilters.year.update(c.year)}
            schema={data.extraFilters.yearSelectorSchema}
            extraProps={{ autoComplete: true }}
            />
        </FormGrid>
      </>}
      headerTailActions={<>
      </>}
      />
  </>);
}
